import axios, { AxiosRequestConfig } from "axios";
import { getAuthType, getToken } from "@/auth";
import { formatToken } from "@/helperMethods/util";
import { logAxiosExceptionToSentry } from "@/sentry";
import { config } from "@/helpers/apiConfig";
import catchRedirect from "@/helpers/catchRedirect";

export const initREST = () => {
  const restInstance = axios.create({
    baseURL: config.root,
  });

  restInstance.interceptors.request.use(
    async (config) => {
      config.headers["Authorization"] = await getToken().then(formatToken);
      config.headers["Authorization-Client"] = getAuthType();
      return config;
    },
    function (error) {
      return Promise.reject(error);
    }
  );

  restInstance.interceptors.response.use(
    (response) => response,
    (error) => {
      logAxiosExceptionToSentry(error);
      catchRedirect(error);
      return Promise.reject(error);
    }
  );

  return (
    method: AxiosRequestConfig["method"],
    endpoint: string,
    payload: Object,
    config: Object = {}
  ) => {
    return restInstance
      .request({
        method,
        url: `/api/${endpoint}`,
        data: payload,
        ...config,
      })
      .then((res: any) => res.data);
  };
};

export const initRemoteRestInstance = (baseURL) => {
  const restInstance = axios.create({
    baseURL,
  });

  restInstance.interceptors.request.use(
    async (config) => {
      config.headers["Authorization"] = await getToken().then(formatToken);
      config.headers["Authorization-Client"] = getAuthType();
      return config;
    },
    function (error) {
      return Promise.reject(error);
    }
  );

  return restInstance;
};
